import React, { useContext } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../../components/Pagination'
import { Context } from '../ChargeHistory'

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col" style={{ width: '25%' }}>Người chơi</th>
              <th scope="col">Hình thức</th>
              <th scope="col" style={{ width: '25%' }}>Số tiền</th>
              <th scope="col" style={{ width: '25%' }}>Phí</th>
              <th scope="col" style={{ width: '25%' }}>Phí cố định</th>
              <th scope="col" style={{ width: '25%' }}>Tổng</th>
              <th scope="col" style={{ width: '25%' }}>Mã đối chiếu</th>
              <th scope="col">Ngày nạp</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => <TableRow rIndex={index} key={`table-keys-lottmekong-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)